<div class="modal-container">

    <div class="modal-header modal-book  d-inline-block">
      <div class="">
          <button class="text-right w-100 modal-clost-btn" (click)="bsModalRef?.hide(); close()" aria-label="Close">&times;</button>
          <h4>Hi there!</h4>
          <p class="mb-5 sub-text">Bookings for more than 21 nights or 9 rooms require an assisted enquiry. Would you like to continue with your enquiry, and our team will get in touch to assist you with your booking?
          </p>
          <div class="mb-4 d-flex  gap-3 resend">
            <button class="btn btn-stripe " (click)="bsModalRef?.hide()" >No</button>
            <button class="btn btn-resend " (click)="goToEnquiry()">Yes</button>
          </div>
        </div>
      
    </div>
  